// extracted by mini-css-extract-plugin
export default {"wrapper":"LogoNew_wrapper__XHVR3","logo":"LogoNew_logo__+UHea"};